import type { Editor } from "@tiptap/react";
import { MenuBarItem } from "./MenuBarItem";
import { MenuBarVariableButton } from "./MenubarVariableButton";

export interface MenuBarProps {
  editor: Editor | null;
  shouldShowVariablesButton?: boolean;
}

export const MenuBar = ({
  editor,
  shouldShowVariablesButton = false,
}: MenuBarProps) => (
  <div className="-mx-3 mb-2 flex items-center gap-0.5 border-b p-1.5">
    <MenuBarItem
      isActive={editor?.isActive("bold")}
      icon="16-bold"
      onClick={() => editor?.chain().focus().toggleBold().run()}
    />
    <MenuBarItem
      isActive={editor?.isActive("italic")}
      onClick={() => editor?.chain().focus().toggleItalic().run()}
      icon="16-italic"
    />
    <MenuBarItem
      isActive={editor?.isActive("underline")}
      onClick={() => editor?.chain().focus().toggleUnderline().run()}
      icon="16-edit-underline"
    />
    {shouldShowVariablesButton && (
      // Editor is of type Editor | null, but the InsertVariableButtonWrapper expects an Editor | undefined
      <MenuBarVariableButton
        editor={editor ?? undefined}
        isActive={editor?.isActive("variables")}
      />
    )}
  </div>
);
